import { forwardRef } from 'react';
import { LinkProps as RRLinkProps, useHref, useLinkClickHandler } from 'react-router-dom';
import { Link, LinkProps } from '@hopskipdrive/react-components';

type RouterLinkProps = RRLinkProps & LinkProps;

const Presentation = ({ replace = false, state, onClick, target, to, ...rest }: RouterLinkProps, ref) => {
  const href = useHref(to);
  const handleClick = useLinkClickHandler(to, {
    replace,
    state,
    target,
  });

  return (
    <Link
      {...rest}
      href={href}
      onClick={(event) => {
        onClick && onClick(event);
        if (!event.defaultPrevented) {
          handleClick(event);
        }
      }}
      ref={ref}
      target={target}
    />
  );
};

export const RouterLink = forwardRef(Presentation);
